import { CurrentDossierProvider, useDefaultContextActions } from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { useParams } from 'react-router';
import { DossierAddFormality } from '../../components';

const AddFormality: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);
    if (!idDossier) {
        console.warn(`Dossier non trouvé paramètres url:  ${idDossier}`);
        throw new Error(`Dossier non trouvé paramètres url:  ${idDossier}`);
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <Container maxWidth="md">
                <DossierAddFormality />
            </Container>
        </CurrentDossierProvider>
    );
};

export default AddFormality;
